export const TeamChatEntitySuggestionsTestIds = {
  ROOT: 'team-chat.entity-suggestions',
  TITLE: 'team-chat.entity-suggestions-title',
  ITEM: 'team-chat.entity-suggestions-item',
  LOADING: 'team-chat.entity-suggestions-loading',
  EMPTY: 'team-chat.entity-suggestions-empty',
};
